import React, { createContext, useContext, useState, useEffect } from 'react';
import { convertFromLiters, formatValue } from '../utils/unitConversion';

const UnitContext = createContext();

export function UnitProvider({ children }) {
  const [selectedUnit, setSelectedUnit] = useState(() => {
    const saved = localStorage.getItem("selectedUnit");
    return saved || 'L';
  });

  useEffect(() => {
    localStorage.setItem("selectedUnit", selectedUnit);
  }, [selectedUnit]);

  const convertValue = (liters) => {
    return convertFromLiters(liters, selectedUnit);
  };

  const formatValueWithUnit = (liters) => {
    const convertedValue = convertValue(liters);
    return formatValue(convertedValue, selectedUnit);
  };

  return (
    <UnitContext.Provider value={{ 
      selectedUnit, 
      setSelectedUnit,
      convertValue,
      formatValueWithUnit
    }}>
      {children}
    </UnitContext.Provider>
  );
}

export function useUnit() {
  const context = useContext(UnitContext);
  if (!context) {
    throw new Error('useUnit must be used within a UnitProvider');
  }
  return context;
} 